<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <cuenta-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import CuentaCrud from "./CuentaCrud";
    export default {
        name: "Cuenta",
        components: {CuentaCrud}
    }
</script>

<style scoped>

</style>

